export const acceptedLifecycle = ['Available', 'Coming Soon', 'Discontinued'];

export interface SorterFieldData {
  reverse?: boolean;
  sortFunc: (arg?: any) => number | void;
  title: string;
}

export interface SortersData {
  featured: SorterFieldData;
  newest: SorterFieldData;
  priceAsc: SorterFieldData;
  priceDesc: SorterFieldData;
}
